import { render, staticRenderFns } from "./BankDetail.vue?vue&type=template&id=e9a8ad32&scoped=true"
import script from "./BankDetail.vue?vue&type=script&lang=js"
export * from "./BankDetail.vue?vue&type=script&lang=js"
import style0 from "./BankDetail.vue?vue&type=style&index=0&id=e9a8ad32&prod&scoped=true&lang=css"
import style1 from "./BankDetail.vue?vue&type=style&index=1&id=e9a8ad32&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9a8ad32",
  null
  
)

export default component.exports